import {
  DEACTIVATE_TMS_FAILED,
  DEACTIVATE_TMS_LOADING,
  DEACTIVATE_TMS_SUCCESS,
  GET_ALLTMS_REMOVE,

} from "../types";

const initialState = {
  loading: false,
  error: null,
  Tms: null,
  status: null,
};

export const deactivateTmsReducer = (
  state = initialState,
  action: { type: any; loading: any; payload: any; status: any; error: any }
) => {
  switch (action.type) {
    case DEACTIVATE_TMS_LOADING:
      return {
        ...state,
        loading: action.loading,
      };
    case DEACTIVATE_TMS_SUCCESS:
      return {
        ...state,
        loading: false,
        Tms: action.payload,
        status: action.status,
        error: null,
      };
    case DEACTIVATE_TMS_FAILED:
      return {
        ...state,
        loading: false,
        Tms: null,
        status: null,
        error: action.error,
      };
    case GET_ALLTMS_REMOVE : 
      return  initialState;
    default:
      return state;
  }
};
